export const DIMMED_CHART_OPACITY = 0.15;
